// src/components/LoginPage.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import axios from '../axiosConfig';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post('/api/login', { email, password });
      console.log(response.data);
      if (response.status === 200) {
        // Redirect to chat page if login is successful
        localStorage.setItem('token', response.data.data.token);
        navigate('/chat');
      } else {
        setError('Invalid credentials');
      }
    } catch (err) {
      setError('An error occurred. Please try again.');
    }
  };

  return (
    <Container>
      <LoginBox>
        <h1>NexBot</h1>
        <form onSubmit={handleLogin}>
          <InputBox>
            <input 
              type="text" 
              placeholder="Email" 
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required 
            />
              <input 
                type="password" 
                placeholder="Password" 
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required 
              />
          </InputBox>
          {error && <Error>{error}</Error>}
          <button type="submit">Login</button>
        </form>
      </LoginBox>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  height: 100vh;
  justify-content: center;
  align-items: center;
  background-color: #f0f0f0;

`;

const InputBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const LoginBox = styled.div`
  padding: 20px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  text-align: center;
  min-width: 300px;
   
  form {
    display: flex;
    flex-direction: column;

    input {
      margin: 10px 0;
      padding: 10px;
      border: 1px solid #ccc;
      border-radius: 4px;
      width: 90%;
      @media screen and (max-width: 600px){
        width: 95%
      }
    }

    button {
      padding: 10px;
      border: none;
      border-radius: 4px;
      background-color: #007bff;
      color: white;
      cursor: pointer;
      @media screen and (max-width: 600px){
        width: 100%;
        align-self: center;
      }
    }
  }
`;

const Error = styled.div`
  color: red;
  margin-bottom: 10px;
`;

export default LoginPage;
